import { FormInstance } from 'antd';
import React, { FC, memo, ReactElement, useCallback } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { ConfirmModal } from 'shared/ui/ConfirmModal';
import { useChangeUserAccess } from '../utils/hooks/useChangeUserAccess';

interface ChangeUserAccessProps {
  userId: string | undefined;
  action: ReactElement;
  formInstance: FormInstance;
  onSuccess?: () => void;
}

export const ChangeUserAccess: FC<ChangeUserAccessProps> = memo((props) => {
  const { userId, action, formInstance, onSuccess } = props;

  const { t } = useAppTranslation('profile');

  const updatedData = formInstance.getFieldsValue();

  const { handleChangeUserAccess, closeConfirmModal, openConfirmModal, isOpenedConfirm, isLoading } = useChangeUserAccess({
    userId,
    updatedData,
    onSuccess,
  });

  const handleClick = useCallback(async (): Promise<void> => {
    try {
      await formInstance.validateFields();
      openConfirmModal();
    } catch (e) {
      console.log(e);
    }
  }, [formInstance, openConfirmModal]);

  return (
    <>
      {React.cloneElement(action, { onClick: handleClick })}
      <ConfirmModal
        isOpened={isOpenedConfirm}
        title={t('Change access details')}
        description={t('Are you sure you want to change access details?')}
        isLoading={isLoading}
        onOk={handleChangeUserAccess}
        onCancel={closeConfirmModal}
      />
    </>
  );
});
